import React from 'react'
import Acronym from 'components/interactive/acronym'
import Citation from 'components/interactive/citation/citation'
import {Acronyms, Citations} from './expandables'
import ProfileImg from 'pages/june-5/races/images/mb.png'
import ProfileImg_w from 'pages/june-5/races/images/mb.webp'
import prevCandImg from 'pages/june-5/races/images/elz-nav.png'
import nextCandImg from 'pages/june-5/races/images/lb-nav.png'
const Data = {
	pageId: "sf-race-cand-michelle-bravo",
	meta: {
		canonicalUrl:"https://bythebay.cool/election/sf-race-cand-michelle-bravo",
		documentTitle:"Michelle Bravo • June 5, 2018 SF",
		socialHeadline:"Michelle Bravo wants to be Mayor of SF",
		socialDescription:"Here's a nonpartisan breakdown of what she's done, her campaign promises, and controversies.",
		socialImage:"https://s3-us-west-1.amazonaws.com/bythebay.cool/socialimages/howtopassalaw.png",
	},
	intro: {
		candidateName: "Michelle Bravo",
		img: {
			_1x_webp: ProfileImg_w,
			_1x: ProfileImg,
		}, 
		color: "pink",
		summary: [
			{
				label: "Running for",
				value: "Mayor of SF",
			},
			{
				label: "Politics",
				value: "Nonpartisan",
			},
			{
				label: "A haiku",
				value: "D10 resident. New to SF politics. Wants a vice-mayor.",
			},
			{
				label: "Past roles",
				value: <span><Citation data={Citations["3"]}>Founder, massage therapy business (2005-Present)</Citation><br/>Military veteran (1989-1993)</span>,
			},
			// {
			// 	label: <span>Ability to <Acronym data={Acronyms.GSD} Acronym>GSD</Acronym></span>,
			// 	value: <span role="img" aria-label="ability to get shit done">💪</span>,
			// },
			{
				label: "Fundraised",
				value: <span role="img" aria-label="amount raised">
					💸 <Citation data={Citations["1"]}>($5K as of 6/2/18)</Citation>
				</span>,
			},
			{
				label: "Did you know",
				value: <span><Citation data={Citations["2"]}>She's a sixth-generation Bay Area native. She's campaigning for mayor just for the experience.'</Citation></span>,
			},
		],
		highlightSection: {
			title: "The latest",
			body: "Michelle is expected to participate in a mayoral candidate forum on May 14 at the Commonwealth Club.",
			link: "https://www.commonwealthclub.org/events/2018-05-14/san-francisco-decides-mayoral-election-2018",
		},
		raceInfo: {
			position: "Mayor of SF",
			link: "/election/sf-race-mayor",
			opponents: [
				{
					name: "London Breed",
					link: "/election/sf-race-cand-london-breed",
				},
				{
					name: "Mark Leno",
					link: "/election/sf-race-cand-mark-leno",
				},
				{
					name: "Jane Kim",
					link: "/election/sf-race-cand-jane-kim",
				},
				{
					name: "Angela Alioto",
					link: "/election/sf-race-cand-angela-alioto",
				},
				{
					name: "Richie Greenberg",
					link: "/election/sf-race-cand-richie-greenberg",
				},
				{
					name: "Amy Farah Weiss",
					link: "/election/sf-race-cand-amy-farah-weiss",
				},
				{
					name: "Ellen Lee Zhou",
					link: "/election/sf-race-cand-ellen-lee-zhou",
				},
			]
		}
	},
	sections: [
		{
			id: "010",
			type: "summary-list",
			data: {
				title: "Campaign Promises",
				subtitle: "What Michelle says she'll do once she's mayor",
				stories: [
					{
						title: "Require all city workers to live in SF",
						description: 
							<ul>
								<li>Offer teachers and first responders low interest home loans or tax breaks</li>
								<li>Ensure at least 20% of affordable housing units are for <Acronym data={Acronyms.SFPD}/> and <Acronym data={Acronyms.SFFD}/> workers</li>
								<li>Require developers and tech companies to pay a high-density tax</li>
								<li>Pass a law requiring 50% of all first responders are required to live in SF by 2025</li>
							</ul>,
					},
					{
						title: "Treat homeless people, aka 'transients,' with compassion",
						description: 
							<ul>
								<li>Use CA’s budget surplus to fund a holistic mental health facility </li>
								<li>Create an app for the <Acronym data={Acronyms.SFPD}/> and <Acronym data={Acronyms.SFFD}/> to track vacant rooms and beds in the city</li>
								<li>Require homeless people to register with social services</li>
							</ul>,
					},
					{
						title: <span>Oppose equipping the <Acronym data={Acronyms.SFPD}/> with Tasers</span>,
						description: 
							<ul>
								<li>Focus on de-escalation tactics</li> 
							</ul>,
					},
					{
						title: <span><a href="http://www.michellebravo.org">Read more on her campaign website</a></span>,
						description: null,
					},
				],
			}
		},
		{
			id: "020",
			type: "video-carousel",
			data: {
				title: "Watch Michelle talk",
				subtitle: <span>It's not her <Acronym data={Acronyms.IRL}/>, but it's close</span>,
				videos: [
					{
						caption: "KTVU interview (April 2018)",
						link:"https://www.youtube-nocookie.com/embed/ju_KHTHk-uU",
					},
					{
						caption: "SkyLink TV interview (May 2018)",
						link: "https://www.youtube-nocookie.com/embed/oQHZfUIXtfE",
					},
				],
			},
		},
		{
			id: "030",
			type: "summary-list",
			data: {
				title: "Stuff Michelle has done",
				subtitle: "Michelle is new to politics and hasn't passed any laws.",
				stories: [
					{
						title: null,
						description:null,
					},
				],
			},
		},
		{
			id: "040",
			type: "photo-carousel",
			data: {
				title: "Politicians are \"people\" too",
				subtitle: "Highlights from Michelle's public",
				socialMedia: [
					{
						label: "Instagram",
						link: "https://www.instagram.com/michellebravosf/?hl=en",
					},
					{
						label: "Twitter",
						link: "https://twitter.com/forSFMayor/",
					},
				],
				images: [
					{
						src: "https://scontent-sjc3-1.cdninstagram.com/vp/611ec1f8ef04a6a4d23c97a205b02629/5B93E57C/t51.2885-15/e35/28153992_155427705160489_8885262551932207104_n.jpg",
						caption: "Being young",
						link:"https://www.instagram.com/p/BfhB06FFheT/?hl=en&taken-by=michellebravosf",
					},
					{
						src: "https://scontent-sjc3-1.cdninstagram.com/vp/a6898d476ac9b7f7889c45d4979df742/5B77DB0F/t51.2885-15/e35/28155743_151517855531839_6259365108170883072_n.jpg",
						caption: "Posing with Santa",
						link:"https://www.instagram.com/p/Bfg3k8PF4ew/?hl=en&taken-by=michellebravosf",
					},
				],
			},
		},
		{
			id: "050",
			type: "endorsements-list",
			data: {
				title: "Lovers & haters",
				subtitle: "Michelle has yet to receive any political endorsements.",
				lovers: [
					{
						author: "Bruno Mars",
						quote: <span><span role="img" aria-label="music note">🎶</span>And when you smile, the whole world stops and stares for awhile, cause you’re amazing, just the way you are.<span role="img" aria-label="music note">🎶</span></span>,
						link: "https://www.youtube.com/watch?v=LjhCEhWiKX",  
					},
				],
				haters: [
					{
						author: 'Taylor Swift',
						quote: <span><span role="img" aria-label="music note">🎶</span>Now we got problems<br/>And I don't think we can solve them<br/>You made a really deep cut<br/>And baby now we got bad blood<span role="img" aria-label="music note">🎶</span></span>,
						link: "https://www.youtube.com/watch?v=QcIy9NiNbmo",
					},
				],
			},
		},
		// {
		// 	id: "060",
		// 	type: "fundraising-summary",
		// 	data: {
		// 		title: "🤑 Where the money comes from",
		// 		subtitle: "Where Jane Kim is getting her money",
		// 		amountRaised: "$2.6M",
		// 		asOfDate:"June 30, 2018",
		// 		topFunders: [
		// 			{
		// 				blurb: "Pilot Construction Management, Inc. - $100K - San Francisco for London Breed Mayor 2018, Sponsored by the San Francisco Firefighters Local 798",
		// 			},
		// 			{
		// 				blurb: "SF Firefighters - $65K - San Francisco for London Breed Mayor 2018, Sponsored by the San Francisco Firefighters Local 798",
		// 			},
		// 			{
		// 				blurb: "Pia Oien - $59,997 - It's Our Time, SF Women Supporting London Breed for Mayor, 2018",
		// 			},
		// 		],
		// 	},
		// },
		{
			id: "070",
			type: "links-block",
			data:{
				subsections:[
					{
						subsectionTitle: "Other links",
						links: [
							{
								text:"Michelle's campaign website",
								url:"http://www.michellebravo.org/"
							},
							{
								text:"SF Ethics: Campaign Finance",
								url:"https://sfethics.org/ethics/2018/03/campaign-finance-dashboards-june-5-2018-and-november-6-2018-elections.html"
							},
						],
					},
				],
			}
		},
		{
			id: "080",
			type: "bottom-nav",
			data: {
				tiles: [
					{
						img: prevCandImg,
						to: "/election/sf-race-cand-ellen-lee-zhou",
						style: "",
						text: "Ellen Lee Zhou",
					},
					{
						img: nextCandImg,
						to: "/election/sf-race-cand-london-breed",
						style: "",
						text: "London Breed",
					}
				],
			}
		},
	],
}

export default Data;


// WEBPACK FOOTER //
// ./src/pages/june-5/races/data/SFMayor/mb/data.js